import { Component, inject, DOCUMENT } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from "./component/layout/footer/footer.component";
import { HeaderComponent } from "./component/layout/header/header.component";
import { Store } from '@ngrx/store';
import { AccountService } from './services/account.service';
import { authUserFeature } from './store/authUser.store';
import { combineLatest, filter, lastValueFrom, take, takeUntil } from 'rxjs';
import { Base } from './component/wrapper/base-wrapper.component';
import { accountFeature } from './store/account.store';
import { Logger } from './helper/logger';
import { SiteMessageBarComponent } from "./component/elements/site-message-bar";
import { MessageBarService } from './services/message-bar.service';
import { LocationPublic } from '../../globalTypes/account.types';
import { LOCATION_LABEL } from '../../globalTypes/configs';

const log = new Logger('AppComponent');

@Component({
  selector: 'msh-root',
  imports: [RouterOutlet, FooterComponent, HeaderComponent, SiteMessageBarComponent],
  template: `
    <div class="flex flex-col min-h-screen ">
      <msh-header [mode]="headerlessRoutes.includes(router.url) ? 'actionless' : 'standard'"></msh-header>
      <div class=" mt-16 grow flex flex-col  text-copy bg-back">
        <router-outlet />
      </div>
      <msh-footer></msh-footer>
    </div>
    <msh-site-message-bar></msh-site-message-bar>
  `,
  styles: [],
})
export class AppComponent extends Base<AppComponent> {
  private readonly document = inject(DOCUMENT);
  private messagesService = inject(MessageBarService);
  title = 'Mobile Storehouse';
  headerlessRoutes = ["/", "/register-your-interest", "/test-page"];
  currentUid = '';
  constructor(
    private store: Store,
    public router: Router,
    private accountService: AccountService,
  ){
    super();

    // AUTO ACCEPT INVITE IF NO LOCATION EXISTS
    combineLatest([
      this.store.select(accountFeature.selectInvitationsReceived),
      this.store.select(accountFeature.selectLocation),
      this.store.select(accountFeature.selectHasInitialized),
    ])
    .pipe(takeUntil(this.$destroy)).subscribe( async ([invite, location, hasInitialized]) =>{
      console.log({invite, location, hasInitialized})
      if(hasInitialized && invite.length > 0){
        const locations: {[locationId: string]: LocationPublic} = await lastValueFrom(this.store.select(accountFeature.selectLocations).pipe(take(1)));
        // Auto accept invite if no location exists, but if there is a location, show message bar with option to accept invite
        if(!location && invite.length === 1){
        //   // auto accept invitation
          log.warn('Auto accepted invitation')
          this.accountService.acceptInvite(invite[0]);
        } else {
          // Global message bar / listener / add invite to messages some how
        
          invite.forEach(invite => {
      console.log({invite, i: invite, hasInitialized, locations})
            const location = !!invite.invitedToLocationId && locations[invite.invitedToLocationId] ? locations[invite.invitedToLocationId] : {name: `a ${LOCATION_LABEL}`};
            this.messagesService.show({
              id: `invite-${invite.id}`,
              type: 'info',
              title: `Invitation to join ${location?.name}!`,
              message: `You have been invited by ${invite.invitedBy}.`,
              ctaLabel: 'Accept Invite',
              ctaAction: () => {
                this.accountService.acceptInvite(invite);
                this.messagesService.dismiss(`invite-${invite.id}`);
                // this.router.navigate(['/account/invites'])
              },
              dismissible: true,
              persistDismissal: true,
            })
          });
        }
      }
    })

    const browserDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    if(browserDarkMode){
      this.controlDarkMode(true);
    }
    
    // TODO Only select preferences or dark mode specifically
    this.store.select(authUserFeature.selectUser).pipe(filter(u=>!!u), takeUntil(this.$destroy)).subscribe(user => {
      console.log('User preferences test ', user)
      this.controlDarkMode( user.preferences?.isDarkMode)
      // if(user.id !== this.currentUid){ // FIXME // [ ] add another check for if account info is already loaded for this uid
      //   this.accountService.loadMyAccountInfo('app component');
      // }
      this.currentUid = user.id;
    })
  }

  controlDarkMode(isDarkMode: boolean){
    if(isDarkMode){
      this.document.documentElement.classList.add("dark");
      this.document.documentElement.classList.remove("light");
    }else{
      this.document.documentElement.classList.remove("dark");
      this.document.documentElement.classList.add("light");
    }
  }
}
